import { render } from "./App.vue?vue&type=template&id=20b1205e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=20b1205e&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\高尔夫\\ipad版点餐\\ipad-b\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__